
import { Component, Vue } from "vue-property-decorator";
import { queryTableDataDetail } from "@/api/api-basic";
import { objAny } from "@/common/common-interface";
@Component
export default class EquipmentTable extends Vue {
  private updataUpgradePack: objAny = {};
  private modalShow = false;
  private isQuery = true;
  private itemData: objAny = {};
  private formItem: objAny = {
    protocolIndex: "",
    serialNumber: ""
  };

  private loading = false;
  private detailsData: objAny = {};
  private detailsFormList: object = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: "序列号",
      key: "serialNumber",
      minWidth: 103
    },
    {
      title: "升级时间",
      key: "upgradeTime",
      minWidth: 103
    },
    {
      title: "升级结果",
      key: "upgradeResult",
      minWidth: 83
    },
    {
      title: "详情",
      key: "upgradeDetail",
      minWidth: 140
    }
  ];
  private debugTableList: object[] = [];
  private debugTableColumns: object[] = [
    {
      title: "序列号",
      key: "serialNumber",
      minWidth: 103
    },
    {
      title: "枪号",
      key: "gunNum",
      minWidth: 103
    },
    {
      title: "升级时间",
      key: "beginTime",
      minWidth: 103
    },
    {
      title: "调试结果",
      key: "result",
      minWidth: 83
    },
    {
      title: "详情",
      key: "detail",
      minWidth: 140
    }
  ];
  public open(item: objAny): void {
    this.modalShow = true;
    this.formItem.serialNumber = item.serialNumber;
    this.getTableList();
    this.itemData = item;
    this.debugTableList = item.debugResultList;
    if (item.upgradeTime) {
      this.tableList = [
        {
          upgradeTime: item.upgradeTime,
          upgradeResult: item.upgradeResult,
          upgradeDetail: item.upgradeDetail,
          serialNumber: item.serialNumber
        }
      ];
    } else {
      this.tableList = [];
    }
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await queryTableDataDetail({
      serialNumber: this.formItem.serialNumber
    });

    if (ret.status === this.$config.apiStatus) {
      this.detailsData = ret.data;
      if (ret.data[0]) {
        this.formItem.protocolIndex = 0;
        this.detailsFormList = ret.data[0].optionList;
      }
    }
    this.loading = false;
  }
}
